import MockupPreviewDynamicModel from "./mockup-preview/mockup-preview-dynamic/MockupPreviewDynamicModel.js";
import MockupPreviewImageModel from "./mockup-preview/mockup-preview-image/MockupPreviewImageModel.js";
import MockupPreviewModel3d from "./mockup-preview/mockup-preview-model-3d/MockupPreviewModel3d.js";
import MockupPreviewVideoModel from "./mockup-preview/mockup-preview-video/MockupPreviewVideoModel.js";
import MockupPreviewYoutubeVideoModel from "./mockup-preview/mockup-preview-youtube-video/MockupPreviewYoutubeVideoModel.js";
export default class MockupModel {
  constructor({
    id = null,
    material = null,
    active = false,
    mockupPreviews = [],
    color = "fff",
  }) {
    this.id = id;
    this.jsClass = "MockupModel";
    this.material = material;
    this.active = active;
    this.mockupPreviews = this.mountPreviews(mockupPreviews);
    this.color = this.mountColor(color);
  }

  json() {
    return {
      id: this.id,
      jsClass: this.jsClass,
      material: this.material,
      active: this.active,
      mockupPreviews: this.mockupPreviews
        ? this.mockupPreviews.map((p) => (p.json ? p.json() : el))
        : [],
      color: this.color,
    };
  }

  mountPreviews = (mockupPreviews) =>
    mockupPreviews.map((preview) => {
      if (preview.jsClass === "MockupPreviewDynamicModel")
        preview = new MockupPreviewDynamicModel(preview);
      else if (preview.jsClass === "MockupPreviewImageModel")
        preview = new MockupPreviewImageModel(preview);
      else if (preview.jsClass === "MockupPreviewVideoModel")
        preview = new MockupPreviewVideoModel(preview);
      else if (preview.jsClass === "MockupPreviewYoutubeVideoModel")
        preview = new MockupPreviewYoutubeVideoModel(preview);
      else if (preview.jsClass === "MockupPreviewModel3d")
        preview = new MockupPreviewModel3d(preview);
      return preview;
    });

  addPreview = (jsClass) => {
    let preview;
    if (jsClass === "MockupPreviewDynamicModel")
      preview = new MockupPreviewDynamicModel({
        order: this.mockupPreviews.length,
      });
    else if (jsClass === "MockupPreviewImageModel")
      preview = new MockupPreviewImageModel({
        order: this.mockupPreviews.length,
      });
    else if (jsClass === "MockupPreviewModel3d")
      preview = new MockupPreviewModel3d({
        order: this.mockupPreviews.length,
      });
    else if (jsClass === "MockupPreviewVideoModel")
      preview = new MockupPreviewVideoModel({
        order: this.mockupPreviews.length,
      });
    else if (jsClass === "MockupPreviewYoutubeVideoModel")
      preview = new MockupPreviewYoutubeVideoModel({
        order: this.mockupPreviews.length,
      });
    this.mockupPreviews.push(preview);
  };

  mountColor = (color) => {
    color = color.replace("#", "");
    return color;
  };
}
